import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
// import { useMount, useUnmount } from "react-use";

import "./loading.css";
import logo from "../assets/images/logo.png";

const Loading = ({ text = "Please wait...", where = 0, timeout = 0 }) => {
  // where = isNaN(where) ? Number.where : where;
  const navigate = useNavigate()
  // let timer1;

  useEffect(() => {
    let timer1
    if (timeout !== 0) {
      timer1 = setTimeout(() => {
        return navigate(where);
      }, timeout * 1000);
    };
    return () => {
      clearTimeout(timer1)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  //  useMount(() => {       
  //   if (timeout !== 0) {
  //     timer1 = setTimeout(() => {
  //       return navigate(where);
  //     }, timeout * 1000);
  //   };
  //  });
  //  useUnmount(() => { clearTimeout(timer1) });


  // const doOnClick = () => {
  //   navigate(where);
  // }


  return (
    <>
      <div
        className="page-box col-8"
        title="Click to close"
      // onClick={doOnClick}
      >
        <div className="loading_container loading">
          <img src={logo} alt="altimage"></img>
        </div>
        <p>{text}</p>
      </div>
    </>
  );
};

export default Loading;
